import React from 'react';
import ReactMarkdown from 'react-markdown';
import { graphql, Link } from "gatsby";

import Layout from '../../components/Layout';
import Button from '../../components/Button';
import ChevronRight from '../../images/chevron-right.svg';

const PersonaPage = (props) => {
  const data = props.data.strapiPersona;
  // const schemes = data.Schemes.sort(() => .5 - Math.random()).slice(0, 3); // Gets 3 random schemes from the list

  return (
    <Layout title="Persona Page">
      <div className="py-8 bg-white">
        <div className="container mx-auto px-12">
          <h1 className="text-2xl font-semibold mb-4">
            {data.Name}
          </h1>

          <div className="sm:flex">
            <div dangerouslySetInnerHTML={{ __html: data.Image.localFile.childSvg.content.data }} title={data.Image.alternativeText} className="h-80 sm:h-auto" />
            <div className="flex-1 mt-4 sm:mt-0 sm:ml-12">
              <div className="prose max-w-5xl">
                <ReactMarkdown children={data.RichContent} />
              </div>
            </div>
          </div>

          <section className="mt-8">
            <p className="text-lg font-semibold mb-4">Find support</p>
            <p>Use our form to find the right funding option for you:</p>
            <div className="mt-8 max-w-sm">
              <Button
                className="border-orange-darkest border-2 bg-orange-dark shadow-md"
                primary="true"
                state={{persona: data.Slug}}
                tag={Link}
                to="/what-schemes-are-available-for-me/location"
              >
                Start the form
                <img className="inline ml-2 -mt-px" src={ChevronRight} alt="" />
              </Button>
            </div>
          </section>
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query PersonaQuery($Slug: String) {
    strapiPersona(Slug: {eq: $Slug}) {
      Slug
      Name
      Image {
        alternativeText
        localFile {
          childSvg {
            content {
              data
            }
          }
        }
      }
      Content
      RichContent
      Schemes {
        Image {
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
        Title
        Snippet
        ShowForm
        ShowSchemePage
        Slug
      }
    }
  }
`;

export default PersonaPage;